// extracted by mini-css-extract-plugin
module.exports = {"bottomBar":"ModelForm_bottomBar__NvjVM","form":"ModelForm_form__20dUm"};